import React from 'react';
import { ThirdPartyLicensesView } from 'components/third-party-licenses';

export const ThirdPartyLicensesPage: React.FC = () => <ThirdPartyLicensesView />;
